import { Tabs } from 'antd'
import { useQueryState } from 'nuqs'
import React from 'react'
import AuthorComp from './author/AuthorComp'
import BlogComp from './blog/BlogComp'

const BlogsMainComp : React.FC = () => {
const [tab, setTab] = useQueryState("tab",{
        defaultValue:"author",
        shallow:true
    })

const handleChangeTab = (key:string) => {
    setTab(key);
}


const items = [
    {
        key:"author",
        label:"Author"
    },
    {
        key:"blog",
        label:"Blog"
    },
]    


  return (
    <div>
     <Tabs
        activeKey={tab}
        onChange={handleChangeTab}
        items={items}
        size="middle"
        className="text-xl"
      />

      {tab === "author" && <AuthorComp />}
      {tab === "blog" && <BlogComp />}

    </div>
  )
}

export default BlogsMainComp